import { supabase } from "@/lib/supabaseClient";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function apiPost(path, body, authToken) {
  // authToken pins the call to a specific session (e.g. the invite-flow token) —
  // otherwise we authenticate with whatever the shared browser storage holds.
  const token = authToken || (await supabase.auth.getSession()).data?.session?.access_token;
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = json.detail;
    const err = new Error(typeof detail === "string" ? detail : detail?.message || "Request failed");
    if (detail && typeof detail === "object") err.detail = detail;
    err.status = res.status;
    throw err;
  }
  return json;
}

export async function apiGet(path, authToken) {
  const token = authToken || (await supabase.auth.getSession()).data?.session?.access_token;
  const res = await fetch(`${API}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = json.detail;
    const err = new Error(typeof detail === "string" ? detail : detail?.message || "Request failed");
    if (detail && typeof detail === "object") err.detail = detail;
    err.status = res.status;
    throw err;
  }
  return json;
}
